import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5c111551&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppLayout: require('/codebuild/output/src3219672180/src/Cloud-AQMS-ServicePoint/src/qengine-servicepoint-ui/components/AppLayout/AppLayout.vue').default})
